import * as React from 'react';
import styled from 'styled-components';

export interface ContainerProps {
  children: React.ReactNode | React.ReactNodeArray;
  stretched?: boolean;
}

export const StyledContainer = styled.div<ContainerProps>`
  max-width: ${({stretched}) => !stretched && '930px'};
  box-sizing: border-box;
  padding: 0 16px;
  width: 100%;
  margin: 0 auto;
  
  @media (max-width: 680px) {
    padding: 0 5px;
  }
`;

/**
 * The component wrap and centered content
 * @param {ContainerProps} props
 * @constructor
 */
export default function Container(
    props: ContainerProps,
): React.ReactElement<ContainerProps> {
  return (
    <StyledContainer {...props}>
      {props.children}
    </StyledContainer>
  );
}
